import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 9h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2H7a1 1 0 0 1 0-2h2V7a1 1 0 1 1 2 0v2zm10.45 11.6c.185.298.202.665.03.836a.583.583 0 0 1-.81 0l-5.51-5.497-.28.229c-1.313 1.072-2.978 1.657-4.75 1.657a7.705 7.705 0 0 1-7.73-7.713A7.705 7.705 0 0 1 10.13 2.4c4.283 0 7.73 3.44 7.73 7.712 0 1.767-.585 3.428-1.66 4.739l-.23.28 5.48 5.468zm-11.32-3.847c3.64 0 6.655-2.967 6.655-6.64 0-3.716-2.932-6.64-6.655-6.64-3.723 0-6.654 2.924-6.654 6.64 0 3.715 2.931 6.64 6.654 6.64z"
});

var SvgZoomIn = function SvgZoomIn(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgZoomIn;